var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dot-indicator",class:( _obj = { blink: _vm.blink }, _obj[_vm.colorClass] = true, _obj ),style:(_vm.sizeStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }